<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input placeholder="请输入地址" v-model="filter.address" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="站点名" prop="name"></el-table-column>
      <el-table-column label="站点类型" prop="station_type"></el-table-column>

      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onRefresh(row)" v-permision_tjtf="'refresh'">刷新</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增时选择组织弹框 -->
    <select-org :show.sync="visible.selectOrg" @confirm="confirmSelectOrg"></select-org>

    <!-- 时间段计费模型 -->
    <charging-config :show.sync="visible.costModel" @confirm="getModelId" :params="modelParams" :type="seletType" :billingModel="billingModel"></charging-config>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import chargingConfig from "./components/charging-config.vue"
import selectOrg from "./components/select-org.vue"
import { getPowerSiteList, freshPowerSite, delPowerSite, addPowerSite } from "@/api/dev_archive"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload, chargingConfig, selectOrg },
  data() {
    return {
      visible: {
        editGroup: false,
        costModel: false,
        selectOrg: false
      },
      uploadhandlerimgs: "",
      placeTypeOptions: [
        { name: "小区", value: 1 },
        { name: "公共用地", value: 2 },
        { name: "厂区", value: 3 },
        { name: "办公楼", value: 4 },
        { name: "超市", value: 5 }
      ],
      tableData: [],
      form: {
        name: "",
        address: "",
        remark: "",
        community_id: "",
        gps_lat: "",
        gps_lng: "",
        place_type: "",
        pic_json: []
      },
      seletType: {},
      billingModel: "powersite",
      modelParams: {},
      communityOptions: [],
      formRules: {},
      filter: {
        name: "",
        address: ""
      },
      loading: false,
      isUpdate: true,
      gid: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      name: [{ required: true, message: "请输入站点名", trigger: "blur" }],
      address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      gps_lat: [{ required: true, message: "请输入纬度", trigger: "blur" }],
      gps_lng: [{ required: true, message: "请输入经度", trigger: "blur" }],
      place_type: [{ required: true, message: "请选择产地类型", trigger: "change" }],
      community_id: [{ required: true, message: "请选择所属社区", trigger: "change" }]
    }
    this.getData()
  },
  methods: {
    getPlaceTypeName(value) {
      const option = this.placeTypeOptions.find((item) => item.value == value)
      return option ? option.name : value
    },

    getModelId() {
      this.getData()
    },

    editChargingConfig(row) {
      this.seletType = row
      this.modelParams = { charging_config_id: row.charging_config_id, power_site_id: row.ID }
      this.visible.costModel = true
    },

    fileChange(fileList, field) {
      this.uploadhandlerimgs = ""
      this.form[field] = fileList
      fileList.forEach((d) => {
        this.uploadhandlerimgs += d.url + ","
      })
    },

    getFirstImageUrl(picJsonString) {
      if (!picJsonString) return null

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            const validPics = picArray.filter((pic) => pic.path && pic.path.trim() !== "")
            if (validPics.length > 0) {
              return validPics[0].path
            }
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          if (urls.length > 0) {
            return urls[0].trim()
          }
        }
        return null
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        if (urls.length > 0) {
          return urls[0].trim()
        }
        return null
      }
    },

    getAllImageUrls(picJsonString) {
      if (!picJsonString) return []

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            return picArray.filter((pic) => pic.path && pic.path.trim() !== "").map((pic) => pic.path)
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          return urls.map((url) => url.trim())
        }
        return []
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        return urls.map((url) => url.trim())
      }
    },

    async onAdd() {
      this.visible.selectOrg = true
    },

    confirmSelectOrg(item) {
      this.visible.selectOrg = false
      console.log("ssssss", item)
      addPowerSite({ orgid: item.Id }).then((res) => {
        this.$message.success(res.msg)
        this.toFilter()
      })
    },

    onDelete(row) {
      this.$confirm("确定要删除该站点吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delPowerSite(row).then(() => {
            this.$message.success(`删除成功`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },
    onRefresh(row) {
      this.$confirm("确定要刷新该站点三元信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          freshPowerSite(row).then(() => {
            this.$message.success(`刷新成功`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },

    getData() {
      this.loading = true
      getPowerSiteList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        ...this.filter
      })
        .then((res) => {
          const communityMap = {}
          this.communityOptions.forEach((community) => {
            communityMap[community.ID] = community.name
          })

          this.tableData = res.data.map((item) => {
            return {
              ...item,
              community_name: communityMap[item.community_id] || item.community_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.station-img {
  width: 80px;
  height: 80px;
}
</style>
